import { useEffect, useState } from 'react'
import { useDirectiveContext } from '@components/Reports/DispatchDirective/DirectiveContext'
import axios from 'axios'
import api from '@utils/api'
import { generateChartData } from '@components/Reports/DispatchDirective/util'
export const useDirectiveOrders = () => {
  const { selectedDate, selectedPrice, selectedDirective } = useDirectiveContext()
  const [ordersLoading, setOrdersLoading] = useState()
  const [unfilteredOrders, setUnfilteredOrders] = useState([])
  const [optionsCancelToken, setOptionsCancelToken] = useState()
  const [chartData, setChartData] = useState()

  useEffect(() => {
    const hasVolume = selectedPrice
      ? selectedPrice.loaded + selectedPrice.scheduled !== 0
      : selectedDirective.loaded + selectedDirective.scheduled !== 0

    const getData = async (newToken) => {
      setOrdersLoading(true)
      try {
        const resp = await api.getDailyDirectiveAnalytics(
          {
            as_of: selectedDate.toISOString(),
            curve_group_ids: [selectedDirective.curve_group_id],
            curve_ids: selectedPrice ? selectedPrice.curve_ids : selectedDirective.curve_ids,
            contract_terminal_product_suppliers: selectedPrice
              ? [
                  {
                    terminal_id: selectedPrice.terminal_id,
                    supplier_id: selectedPrice.supplier_id,
                    product_id: selectedPrice.product_id,
                    contract: selectedPrice.contract,
                  },
                ]
              : selectedDirective.contract_terminal_product_suppliers,
          },
          newToken
        )
        if (resp) {
          setOrdersLoading(false)
          setUnfilteredOrders(resp?.data.orders)
          if (hasVolume) {
            setChartData(
              generateChartData(resp.data.chart.volumes, resp.data.chart.directive_min, resp.data.chart.directive_max)
            )
          } else {
            setChartData(undefined)
          }
        }
      } catch (err) {
        setOrdersLoading(false)
      }
    }

    const newToken = axios.CancelToken.source()
    if (optionsCancelToken) {
      optionsCancelToken.cancel()
    }
    setOptionsCancelToken(newToken)
    getData(newToken)
  }, [selectedDirective, selectedPrice])
  return { unfilteredOrders, ordersLoading, chartData }
}
